module.exports = __webpack_public_path__ + "static/img/fullscreen-image_subscribe_768.a18a7ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/fullscreen-image_subscribe_768.png
// module id = cLVp
// module chunks = 0